<template>
    <Fieldset
        :heading="!hide_heading ? 'Insurance HPI Checks' : null"
    >
        <LoadingSection v-if="state.checks_loading && !state.checks_loaded" />

        <AssetInsuranceChecksList
            v-if="state.checks_loaded"
            :checks="state.checks"
            :refresh="getInsuranceChecks"
        />

        <AssetInsuranceCheckField
            v-if="allow_create"
            :asset_id="asset_id"
            :create_types="create_types"
            :refresh="getInsuranceChecks"
        />
    </Fieldset>
</template>

<script>
import { reactive, computed, onMounted, watch } from "vue"
import { useCheckStore } from "@sto/check.store"
import { useSystemStore } from "@sto/system.store"

import AssetInsuranceCheckField from "@par/asset/AssetInsuranceCheckField.vue"
import AssetInsuranceChecksList from "@par/asset/AssetInsuranceChecksList.vue"
import LoadingSection from "@glo/LoadingSection.vue";

export default {
    props: ['asset_id', 'allow_create', 'view_types', 'create_types', 'hide_heading'],
    components: {
        LoadingSection,
        AssetInsuranceChecksList,
        AssetInsuranceCheckField
    },
    setup (props, { emit }) {

        const SYSTEM_STORE = useSystemStore()
        const CHECK_STORE = useCheckStore()

        const state = reactive({
            checks_loading: false,
            checks_loaded: false,
            checks: []
        })

        const get_request_types_string = computed(() => {
            if (typeof props.view_types === 'string') return props.view_types
            if (Array.isArray(props.view_types)) return props.view_types.toString()
            return null
        })

        const getInsuranceChecks = async () => {

            if (state.checks_loading || !props.asset_id) return

            try {
                state.checks_loading = true

                let params = [];
                if (get_request_types_string.value) params.push({ key: 'type', value: get_request_types_string.value })
                const checks = await CHECK_STORE.listForAsset(props.asset_id, params)
                state.checks = Array.isArray(checks?.checks)
                    ? checks.checks
                    : []

            } catch (error) {
                console.error('CHECK_STORE.listForAsset error', error)
                SYSTEM_STORE.addError('Error', error?.message || 'There was a probem fetching this asset\'s insurance checks')

            } finally {
                state.checks_loading = false
                state.checks_loaded = true
            }
        }
        watch (
            () => props.asset_id,
            () => {
                getInsuranceChecks()
            }
        )

        onMounted(() => {
            getInsuranceChecks()
        })

        return {
            state,
            getInsuranceChecks
        }
    }
}
</script>